import React, { useEffect, useRef, useState } from "react";
import "./pos.scss";
import ProductList from "./components/ProductList";
import ActionButtons from "./components/ActionButtons";
import Items from "./components/Items";
import PosTop from "./components/PosTop";
import { useSelector, useDispatch } from "react-redux";
import OrderStatus from "./components/OrderStatus";
import HoldedData from "./components/HoldedData";
import { RootState } from "../../store/store";
import CustomerModel from "./components/popups/customerlist/CustomerModel";
import { resetPos, addItem, posChange } from "../../store/pos/posSlice";

function Pos() {
  const [openOrder, setopenOrder] = useState(false);
  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [editBillNumber, setEditBillNumber] = useState<string | null>(null);

  const inputRef = useRef<HTMLInputElement>(null);
  const barcode = useRef<HTMLInputElement>(null);
  const itemsRef = useRef<any>(null);

  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    containerRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Tab") {
      e.preventDefault();
      inputRef.current?.focus();
    }
    if (e.key === "Shift") {
      barcode.current?.focus();
    }
  };

  const [openKeyboard, setOpenKeyboard] = useState(false);
  const { customerId, saleType } = useSelector(
    (state: RootState) => state.pos.current,
  );
  const dispatch = useDispatch();

  const [editOrderNumber, setEditOrderNumber] = useState<string | null>(null);
  const [editOrderItems, setEditOrderItems] = useState<any[]>([]);

  const handleEditOrder = (orderNumber: string, items: any[]) => {
    dispatch(resetPos());
    items.forEach((item) => {
      dispatch(
        addItem({
          ...item,
          itemId: item.itemId,
          quantity: Number(item.quantity),
          price: item.price,
          name: item.itemName || item.name,
          dineIn: true,
        }),
      );
    });
    dispatch(posChange({ name: "orderNumber", value: orderNumber }));
    dispatch(posChange({ name: "newOrder", value: false }));
    setEditOrderNumber(orderNumber);
    setEditOrderItems(items);
  };

  return (
    <div
      className="pos fixed inset-0 z-40 flex flex-col bg-erp-surface font-inter outline-none"
      ref={containerRef}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div className="pos_conainer flex h-full min-h-0 flex-col">
        <div className="pos_top shrink-0">
          <PosTop onEditRecentBill={setEditBillNumber} />
        </div>

        {/* Same concept: billing left · items center · status optional */}
        <div className="pos_main !flex !h-auto min-h-0 !flex-1 !gap-2 !overflow-hidden !bg-erp-surface !p-2">
          <aside className="pos_left !flex !h-full !w-[560px] !min-w-[560px] !shrink-0 !flex-col !overflow-hidden !rounded-xl !border !border-erp-line !bg-white !shadow-[0_4px_16px_rgba(11,28,44,0.08)]">
            <ProductList
              keys={inputRef}
              saleType={saleType}
              customerId={customerId}
              editBillNumber={editBillNumber}
              setEditBillNumber={setEditBillNumber}
              editOrderNumber={editOrderNumber}
              editOrderItems={editOrderItems}
              itemsRef={itemsRef}
            />
          </aside>

          <section className="pos_cont !flex !h-full !min-w-0 !flex-1 !flex-col !gap-2 !overflow-hidden">
            <div className="pos_center !flex !min-h-0 !flex-1 !overflow-hidden !rounded-xl !border !border-erp-line !bg-white !shadow-[0_1px_0_rgba(11,28,44,0.04)]">
              <Items ref={itemsRef} barcode={barcode} />
            </div>

            <div
              className={[
                "pos_right !shrink-0 !overflow-hidden !rounded-xl !border !border-erp-line !bg-white",
                openOrder ? "smallbutton" : "",
                !openKeyboard ? "keyboard_close" : "",
              ].join(" ")}
            >
              <ActionButtons
                setopenOrder={setopenOrder}
                onEditOrder={handleEditOrder}
                openKeyboard={openKeyboard}
                setOpenKeyboard={setOpenKeyboard}
              />
            </div>
          </section>

          {openOrder ? (
            <div className="pos_status !w-[220px] !shrink-0 !overflow-hidden !rounded-xl !border !border-erp-line !bg-white">
              <OrderStatus />
            </div>
          ) : null}
        </div>
      </div>

      <HoldedData />

      <CustomerModel
        isOpen={customerModalOpen}
        isCloseMain={() => setCustomerModalOpen(false)}
      />
    </div>
  );
}

export default Pos;
